import createIcon from '../../createIcon';

/**
 * @component @name PieChart
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEgMlYyMkM1LjkzIDIxLjUgMiAxNy4yMSAyIDEyQzIgNi43OSA1LjkzIDIuNSAxMSAyWk0xMy4wMyAyVjEwLjk5SDIyQzIxLjUzIDYuMjUgMTcuNzYgMi40NyAxMy4wMyAyWk0xMy4wMyAxMy4wMVYyMkMxNy43NyAyMS41MyAyMS41MyAxNy43NSAyMiAxMy4wMUgxMy4wM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PieChart = createIcon('PieChart', [
  [
    'path',
    {
      d: 'M11 2V22C5.93 21.5 2 17.21 2 12C2 6.79 5.93 2.5 11 2ZM13.03 2V10.99H22C21.53 6.25 17.76 2.47 13.03 2ZM13.03 13.01V22C17.77 21.53 21.53 17.75 22 13.01H13.03Z',
      key: '69r0fr',
    },
  ],
]);

export default PieChart;
